import { fetchWithAuth } from "./fetchHelpers";

const API_URL = "ors";

export const fetchORSApi = (url, options) => {
  return fetchWithAuth(`${API_URL}/${url}`, options);
};

export const fetchSnapToRoad = (body) =>
  fetchORSApi("v2/snap/driving-car/geojson", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

export const fetchDirections = (body) =>
  fetchORSApi("v2/directions/driving-car/geojson", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

export const fetchReverse = (params = {}, options) => {
  let endpoint = "geocode/reverse";
  const query = new URLSearchParams(params).toString();
  if (query) {
    endpoint += `?${query}`;
  }
  return fetchORSApi(endpoint, options);
};

export const fetchGeoSearch = (params = {}, options) => {
  const query = new URLSearchParams(params).toString();
  let endpoint = "geocode/search";
  if (query) {
    endpoint += `?${query}`;
  }
  return fetchORSApi(endpoint, options);
};

export const fetchGeoAutocomplete = (params = {}, options) => {
  const query = new URLSearchParams(params).toString();
  let endpoint = "geocode/autocomplete";
  if (query) {
    endpoint += `?${query}`;
  }
  return fetchORSApi(endpoint, options);
};
